import { CheckTicketCommand } from './CheckTicketCommand'
import { AccountRepository, AccountTicket } from '@/Domain/Account'
import { AccountDto } from './AccountDto'
import { TokenStorage } from '@/Domain/Account/TokenStorage'

export class CheckTicketCommandHandler {
  private _repository: AccountRepository
  private _tokenStorage: TokenStorage

  constructor (repository: AccountRepository, tokenStorage: TokenStorage) {
    this._repository = repository
    this._tokenStorage = tokenStorage
  }

  async handle (command: CheckTicketCommand): Promise<AccountDto> {
    try {
      const ticket = new AccountTicket(command.ticket())
      const response = await this._repository.checkTicket(ticket)
      this._tokenStorage.storeToken(response.token())
      return AccountDto.fromAccount(response)
    } catch (error) {
      return Promise.reject(error)
    }
  }
}
